// extracted by mini-css-extract-plugin
module.exports = {"integrationBlockHeader":"styles_integrationBlockHeader__34ZR9","leverSelectors":"styles_leverSelectors__Yh2iq","leverSelectorLabel":"styles_leverSelectorLabel__3FMaC"};